module.exports = __webpack_public_path__ + "img/insta3.373ec138.jpg";